module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nuniform vec3 u_Eye, u_Ref, u_Up;\r\nuniform vec2 u_Dimensions;\r\nuniform float u_Time;\r\n\r\nin vec2 fs_Pos;\r\nout vec4 out_Col;\r\n\r\nvoid main() {\r\n  out_Col = vec4(mix(vec3(255., 247., 216.) / 255., vec3(140., 234., 229.) / 255., cos(fs_Pos.x) + fs_Pos.y), 1.);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/flat-frag.glsl
// module id = 76
// module chunks = 0